import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-8 d-flex align-center justify-center flex-grow-1"},[_c(VProgressCircular,{attrs:{"size":"64","indeterminate":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }